<template>
  <div class="d-flex flex-column full-height">
    <div class="flex-column">
      <div class="d-flex text-h4">{{ config.title }}</div>
      <div class="d-flex text-h6">{{ config.subtitle }}</div>
    </div>
    <div class="full-width d-flex flex-grow-1 align-end">
      <v-btn class="ml-auto" dark text @click.stop="$router.push(config.link)">öffnen</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Zueri9AdminWidget',
  props: {
    config: Object,
  },
};
</script>
